<ngx-loading [show]="isProcessing"></ngx-loading>


<div class="row" style="background-color: #fdfdfd;">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body pt-0">
        <div class="row">
          <div class="col-md-12">
            <div class="box-header text-center">
              <h3 class="box-title">Satisfação Serviço Realizado</h3>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12">
                <fieldset>
                  <legend class="w-auto text-center">
                    Período
                  </legend>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">Data Fechamento Inicial</label>
                        <input class="form-control text-center inputDataInicial" type="text"
                          (change)="checkDataValidations()" [textMask]="{ mask: maskData, guide: true }" [ngClass]="{
                            'is-invalid':
                              !this.validations?.inputDataInicialValid ||
                              !this.validations?.inputDataInicialNotEmpty
                          }" />
                        <section *ngIf="!this.validations?.inputDataInicialValid" class="form-text text-danger pl-2">
                          <small>Data inválida</small>
                        </section>
                        <section *ngIf="!this.validations?.inputDataInicialNotEmpty" class="form-text text-danger pl-2">
                          <small><b>Data Fechamento Inicial</b> deve ser informada</small>
                        </section>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">Data Fechamento Final</label>
                        <input class="form-control text-center inputDataFinal" type="text"
                          (change)="checkDataValidations()" [textMask]="{ mask: maskData, guide: true }" [ngClass]="{
                            'is-invalid':
                              !this.validations?.dataFinalMaiordataInicial ||
                              !this.validations?.inputDataFinalValid ||
                              !this.validations?.inputDataFinalNotEmpty
                          }" />
                        <section *ngIf="!this.validations?.dataFinalMaiordataInicial"
                          class="form-text text-danger pl-2">
                          <small><b>Data Fechamento Final</b> deve ser maior que
                            <b>Data Fechamento Inicial</b></small>
                        </section>

                        <section *ngIf="!this.validations?.inputDataFinalValid" class="form-text text-danger pl-2">
                          <small>Data inválida</small>
                        </section>
                        <section *ngIf="!this.validations?.inputDataFinalNotEmpty" class="form-text text-danger pl-2">
                          <small><b>Data Final</b> deve ser informada</small>
                        </section>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="">&nbsp;</label>
                      <button type="button" class="btn btn-primary btn-block mt-1" (click)="submit()"
                        [disabled]="!this.validations.allFieldsValids()">
                        Consultar
                      </button>
                    </div>

                  </div>
                </fieldset>
              </div>
            </div>


          </div>

        </div>


        <div style="border: 2px solid #ddd; margin-bottom: 15px"></div>

        <section class="h500">
          <section class="animated fadeInDown h300" *ngIf="this.results?.total > 0">
            <div class="row">
              <div class="col-md-12">
                <fieldset class="mb-3">
                  <legend class="w-auto txt-blue text-center fs12 fb">
                    Resultado da pesquisa
                  </legend>

                  <div class="row mt-0 mb-2">
                    <div class="col-md-12">
                      <div class="text-center text-muted">
                        <p [innerHTML]="this.subtituloResultadoPesquisa"></p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8 satisfacao">
                      <div class="item-satisfacao">
                        <img src="./assets/images/{{imagens_satisfacao[0]}}" />
                        <div><b>{{ this.results?.naoInformado }}</b> - Não Informado</div>
                      </div>
                      <div class="item-satisfacao">
                        <img src="./assets/images/{{imagens_satisfacao[1]}}" />
                        <div><b>{{ this.results?.excelente }}</b> - Excelente</div>
                      </div>
                      <div class="item-satisfacao">
                        <img src="./assets/images/{{imagens_satisfacao[2]}}" />
                        <div><b>{{ this.results?.muitoBom }}</b> - Muito Bom</div>
                      </div>
                      <div class="item-satisfacao">
                        <img src="./assets/images/{{imagens_satisfacao[3]}}" />
                        <div><b>{{ this.results?.bom }}</b> - Bom</div>
                      </div>
                      <div class="item-satisfacao">
                        <img src="./assets/images/{{imagens_satisfacao[4]}}" />
                        <div><b>{{ this.results?.ruim }}</b> - Ruim</div>
                      </div>
                      <div class="item-satisfacao">
                        <img src="./assets/images/{{imagens_satisfacao[5]}}" />
                        <div><b>{{ this.results?.muitoRuim }}</b> - Muito Ruim</div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-5">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-2">
                          <div class="type-charts">
                            <button type="button" class="btn">
                              <span class="fa fa-bar-chart fa-lg" [ngClass]="{ 'txt-blue': this.tipoGrafico == 'bar' }"
                                (click)="ExibirGrafico('bar')">
                              </span>
                            </button>
                            <button type="button" class="btn">
                              <span class="fa fa-pie-chart fa-lg" [ngClass]="{ 'txt-blue': this.tipoGrafico == 'pie' }"
                                (click)="ExibirGrafico('pie')">
                              </span>
                            </button>
                          </div>
                        </div>
                        <div class="col-md-10">
                          <div *ngIf="this.graficoSeries">
                            <apx-chart *ngIf="this.optionsChart != null" [series]="this.optionsChart?.series"
                              [chart]="this.optionsChart?.chart" [labels]="this.optionsChart?.labels"
                              [dataLabels]="this.optionsChart?.dataLabels"
                              [autoUpdateSeries]="this.optionsChart?.autoUpdateSeries"
                              [xaxis]="this.optionsChart?.xaxis" [yaxis]="this.optionsChart?.yaxis"
                              [plotOptions]="this.optionsChart?.plotOptions"
                              [colors]="this.optionsChart?.colors"></apx-chart>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </section>
          <section class="animated fadeInDown h300" *ngIf="this.results?.total == 0">
            <div class="row">
              <div class="col-md-12"
                style="display: flex; flex-direction: column; align-items: center; align-content: center;">
                <div class="text-danger fs13 mt-3">
                  Nenhum resultado encontrado no período solicitado
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <!-- // box-body-->
    </div>
  </div>
</div>

<app-footer-page></app-footer-page>